var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtAtiviAtivoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49C38.531 49 49.5 38.031 49.5 24.5C49.5 10.969 38.531 0 25 0C11.469 0 0.5 10.969 0.5 24.5C0.5 38.031 11.469 49 25 49Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3295 32.4879C32.3295 32.7707 32.5588 33 32.8416 33H35.2676C35.5504 33 35.7797 32.7707 35.7797 32.4879V28.3997H37.3265C37.7828 28.3997 38.0112 27.8482 37.6886 27.5256L34.4167 24.2536C34.2167 24.0536 33.8925 24.0536 33.6925 24.2536L30.4205 27.5256C30.0979 27.8482 30.3264 28.3997 30.7827 28.3997H32.3295V32.4879Z",
    fill: "#4D78AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5917 13.2646C22.4071 13.0945 22.1651 13 21.914 13H13.6609C12.4724 13 11.5108 13.8961 11.5108 14.9914L11.5 30.923C11.5 32.0183 12.4616 32.9144 13.6501 32.9144H26.6264C27.8149 32.9144 28.7873 32.0183 28.7873 30.923V19.4126C28.7873 19.1333 28.6704 18.8666 28.4649 18.6773L22.5917 13.2646ZM21.4741 19.9701C21.336 19.9701 21.2241 19.8581 21.2241 19.7201V15.0639C21.2241 14.8461 21.4833 14.7325 21.6435 14.8801L26.6958 19.5362C26.8633 19.6905 26.7541 19.9701 26.5264 19.9701H21.4741Z",
    fill: "#4D78AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtAtiviAtivoB);
export default __webpack_public_path__ + "static/media/IconEtAtiviAtivoB.f11b579d62215656236b83cdb3158cd0.svg";
export { ForwardRef as ReactComponent };